import React from 'react';
import './candidateRegistration.css';
import SendIcon from '../../../../assets/images/Ic_send.png';
import { useState } from 'react';
import { ClientPreLoginService } from '../../../../services/clientPreLoginService';
import logo from '../../../../assets/images/Leaderly_client.png';
import profilebackButtonIcon from '../../../../assets/images/Ic_back.png';
import { useLocation } from 'react-router-dom';
import { CandidatePreLoginService } from '../../../../services/candidatePreLoginService';

const CandidateRegister = () => {
    const location = useLocation();
    const isOpenedFromQR = new URLSearchParams(location.search).get("qr") === "true";
    const [errorMessage, setErrorMessage] = useState(sessionStorage.getItem('errorMessage') || '');

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        primaryPhoneNumber: "",
        primaryEmailId: "",
    });
    const [errors, setErrors] = useState({});
    const validate = (name, value) => {
        let error = "";
        if (name === "firstName") {
            if (!/^[A-Za-z ]+$/.test(value)) error = "Name should contain only letters and spaces";
        }
        if (name === "lastName") {
            if (!/^[A-Za-z ]+$/.test(value)) error = "Name should contain only letters and spaces";
        }
        if (name === "primaryPhoneNumber") {
            if (/^0/.test(value)) {
                error = "Mobile number should not start with 0";
            } else if (!/^\+?[0-9]{2}[0-9]{10}$/.test(value)) {
                error = "Enter a valid mobile number (+919876XXXXX0)";
            }
        }
        if (name === "primaryEmailId") {
            if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) error = "Enter a valid email address";
        }

        return error;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newValue = name === "primaryPhoneNumber" ? value.replace(/^0+/, '') : value;
        setFormData({ ...formData, [name]: newValue });
        setErrors({ ...errors, [name]: validate(name, newValue) });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let newErrors = {};
        Object.keys(formData).forEach((key) => {
            if (!formData[key]) {
                newErrors[key] = "This field is required";
            } else {
                newErrors[key] = validate(key, formData[key]);
            }
        });
        setErrors(newErrors);
        if (Object.values(newErrors).every((err) => err === "")) {
            const requestBody = {
                firstName: formData.firstName,
                lastName: formData.lastName,
                primaryPhoneNumber: formData.primaryPhoneNumber,
                primaryEmailId: formData.primaryEmailId,
            };

            try {
                const response = await CandidatePreLoginService.candidateRegistration(requestBody);
                if (response.status === 200) {
                    setErrorMessage("Form submitted successfully!");
                    setFormData({
                        firstName: "",
                        lastName: "",
                        primaryPhoneNumber: "",
                        primaryEmailId: "",
                    });
                    setErrors({});
                } else {
                    console.error("Failed response:", response);
                    setErrorMessage("Failed to submit.");
                }
            } catch (error) {
                console.error("Contact request failed:", error);
                setErrorMessage("Failed to submit");
            }
        }
    };

    return (
        <div className='fluid-container'>
            {errorMessage && (
                <div className="login-alert-overlay">
                    <div className="login-alert-box">
                        <div className="login-alert-content">
                            <p>{errorMessage}</p>
                            <button className="login-alert-button" onClick={() => setErrorMessage('')}>
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* Navbar */}
            <nav className="navbar navbar-light bg-white px-5 " style={{ position: 'fixed', top: '0', left: '0', width: '100%', zIndex: '1000' }}>
                <a className="navbar-brand ">
                    <img src={logo} alt="Logo" />
                </a>
            </nav><br /><br /><br />

            <div className="candidate-contactus-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                {!isOpenedFromQR && (
                    <button className="client-login-back-button" onClick={() => window.history.back()} style={{ outline: 'none' }}>
                        <img src={profilebackButtonIcon} />

                        {' '}Back
                    </button>
                )}
                <div className="candidate-contactus-form" style={{ marginTop: '50px' }}>
                    <h2>By Invitation Only</h2><br />
                    <form onSubmit={handleSubmit}>
                        <input type="text" name="firstName" placeholder="First Name *" value={formData.firstName} onChange={handleChange} spellCheck='false' />
                        {errors.firstName && <p className="error">{errors.firstName}</p>}<br />

                        <input type="text" name="lastName" placeholder="Last Name *" value={formData.lastName} onChange={handleChange} spellCheck='false' />
                        {errors.lastName && <p className="error">{errors.lastName}</p>}<br />

                        <input type="text" name="primaryPhoneNumber" placeholder="Mobile Number*" value={formData.primaryPhoneNumber} onChange={handleChange} spellCheck='false' />
                        {errors.primaryPhoneNumber && <p className="error">{errors.primaryPhoneNumber}</p>}<br />

                        <input type="email" name="primaryEmailId" placeholder="Email Address *" value={formData.primaryEmailId} onChange={handleChange} spellCheck='false' />
                        {errors.primaryEmailId && <p className="error">{errors.primaryEmailId}</p>}<br />



                        <a href="#" className="send-message" onClick={handleSubmit}>
                            <span className="candidate-send-message-text">Submit</span>
                            <span className="send-message-arrow">
                                <img src={SendIcon} alt="sendicon" className="candidate-send-icon-image" />
                            </span>
                        </a>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CandidateRegister;